'use client'
import TruncatedTypography from '@/src/components/common/ui/truncatedTypography'
import { IncludeAirport } from '@/src/hooks/srp/includeAirportsManager'
import { Box, Button, Checkbox, Tooltip, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'
import React from 'react'

interface IncludeAirportsFilterProps {
    includeAirports?: IncludeAirport[]
    onAirportSelect: (airportId: string) => void
    onReset: () => void
    shouldShowReset: boolean
    title: string
}

const IncludeAirportsFilter: React.FC<IncludeAirportsFilterProps> = ({
    onAirportSelect,
    onReset,
    shouldShowReset,
    title,
    includeAirports
}) => {
    const t = useTranslations('common')
    return (
        <Box sx={{ p: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 600, color: 'grey.900' }}>
                    {title}
                </Typography>
                {shouldShowReset && (
                    <Button
                        variant="text"
                        size="small"
                        onClick={onReset}
                        sx={{
                            fontSize: '0.75rem',
                            fontWeight: 500,
                            color: 'brand.primary',
                            p: 0,
                            minWidth: 'auto',
                            '&:hover': {
                                bgcolor: 'transparent',
                                color: 'brand.primaryHover'
                            }
                        }}
                    >
                        {t('reset')}
                    </Button>
                )}
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                {/* Individual airlines */}
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                    {includeAirports?.map(airport => (
                        <Box
                            key={airport.value}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                cursor: 'pointer',
                                position: 'relative',
                                '&:hover .airline-only-text': {
                                    opacity: 1
                                }
                            }}
                            onClick={() => onAirportSelect(airport.value)}
                        >
                            <Checkbox
                                checked={!!airport.isSelected}
                                sx={{
                                    color: 'grey.400',
                                    '&.Mui-checked': {
                                        color: 'brand.primary'
                                    },
                                    p: 0.5
                                }}
                            />
                            <Box
                                sx={{
                                    ml: 1.5,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    flex: 1
                                }}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Box sx={{ position: 'relative' }}>
                                        <Tooltip title={airport.label} followCursor>
                                            <TruncatedTypography
                                                fontSize={'0.875rem'}
                                                maxWidth={200}
                                                maxLines={1}
                                                variant="body2"
                                                color="grey.700"
                                            >
                                                {airport.label}
                                            </TruncatedTypography>
                                        </Tooltip>
                                    </Box>
                                </Box>
                                {/* <Typography
                                    variant="body2"
                                    sx={{
                                        fontSize: '0.875rem',
                                        fontWeight: 600,
                                        color: 'grey.900'
                                    }}
                                >
                                    {airport.subLabel}
                                </Typography> */}
                            </Box>
                        </Box>
                    ))}
                </Box>
            </Box>
        </Box>
    )
}

export { IncludeAirportsFilter }
export type { IncludeAirportsFilterProps }
